export default {
  toasts: {
    load_error: 'Échec du chargement des taux de frais',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  rates: {
    title: 'Marge de traitement',
    description:
      "Pourcentage en %, plus un montant fixe et un montant minimum facultatifs par paiement. « Tout mode de paiement » s'applique lorsqu'aucun taux propre au mode de paiement n'existe.",
    default: {
      inherits:
        'Aucun taux Adyen n’est défini : les restaurants de ce partenaire sur l’Adyen de FoodAmigos paient le taux par défaut de FoodAmigos ci-dessous. Un taux défini ici le remplace ; un taux défini pour un restaurant précis reste prioritaire.',
      overridden:
        'Le taux Adyen propre à ce partenaire remplace le taux par défaut de FoodAmigos ci-dessous pour ses restaurants sur l’Adyen de FoodAmigos. Supprimez-le pour revenir au taux par défaut.',
      own_adyen:
        'Ce partenaire traite les paiements sur son propre compte Adyen. Ses restaurants ne paient aucun frais de traitement, sauf si un taux est défini ici ou pour un restaurant en particulier.',
      master:
        'Voici les taux par défaut de FoodAmigos. Chaque partenaire sur l’Adyen de FoodAmigos sans taux Adyen propre les utilise.',
      rows_title: 'Taux par défaut de FoodAmigos',
    },
  },
};
